import { useRef, useState } from "react";
import { Upload, Camera, Check, X, User } from "lucide-react";
import api from "@/lib/api";

export default function StepSelfie({ selfie, setSelfie }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await api.post("/upload", formData, { headers: { "Content-Type": "multipart/form-data" } });
      setSelfie(data.url);
    } catch { /* */ }
    setUploading(false);
  };

  const handleCapture = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "user" } });
      const video = document.createElement("video");
      video.srcObject = stream;
      await video.play();
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext("2d").drawImage(video, 0, 0);
      stream.getTracks().forEach((t) => t.stop());
      canvas.toBlob(async (blob) => {
        if (blob) await handleFile(new File([blob], "selfie.jpg", { type: "image/jpeg" }));
      }, "image/jpeg", 0.8);
    } catch {
      inputRef.current?.click();
    }
  };

  return (
    <div data-testid="step-selfie">
      <h2 className="crm-heading mb-2">Selfie</h2>
      <p className="text-sm mb-6" style={{ color: "var(--crm-text-muted)" }}>
        Tire uma selfie ou envie uma foto para verificação.
      </p>

      <div className="crm-card p-6 max-w-md mx-auto">
        {selfie ? (
          <div className="relative">
            <img src={`${process.env.REACT_APP_BACKEND_URL}${selfie}`} alt="Selfie" className="w-full h-64 object-cover rounded-xl" />
            <button onClick={() => setSelfie(null)}
              className="absolute top-3 right-3 w-8 h-8 rounded-full flex items-center justify-center bg-red-500 text-white">
              <X className="w-4 h-4" />
            </button>
            <div className="mt-4 text-center">
              <span className="crm-badge crm-badge-green"><Check className="w-3 h-3" /> Selfie enviada</span>
            </div>
          </div>
        ) : (
          <div className="text-center py-8">
            <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center" style={{ background: "var(--crm-accent-subtle)", color: "var(--crm-accent)" }}>
              <User className="w-8 h-8" />
            </div>
            <div className="flex gap-3 justify-center">
              <button onClick={() => inputRef.current?.click()} disabled={uploading} className="crm-btn-secondary text-sm py-3 px-6">
                <Upload className="w-4 h-4" /> {uploading ? "Enviando..." : "Upload"}
              </button>
              <button onClick={handleCapture} disabled={uploading} className="crm-btn-primary text-sm py-3 px-6">
                <Camera className="w-4 h-4" /> Tirar Selfie
              </button>
            </div>
          </div>
        )}
        <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={(e) => handleFile(e.target.files[0])} />
      </div>
    </div>
  );
}
